import React from "react";
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
  } from '@chakra-ui/react'

export default function Gpatable(){
    return(
        <Table variant='striped' maxW="360px" mx="auto">
        <TableCaption>Энэ зөвхөн МУИС-ийн дүнгийн систем ба бусад сургуулиудад өөр байж болзошгүй</TableCaption>
        <Thead>
          <Tr>
            <Th>Дүн</Th>
            <Th></Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>95-100</Td>
            <Td>A</Td>
            <Td>4.0</Td>
          </Tr>
          <Tr>
            <Td>90-94</Td>
            <Td>A-</Td>
            <Td>3.6</Td>
          </Tr>
          <Tr>
            <Td>85-89</Td>
            <Td>B</Td>
            <Td>3.1</Td>
          </Tr>
          <Tr>
            <Td>80-84</Td>
            <Td>B-</Td>
            <Td>2.7</Td>
          </Tr>
          <Tr>
            <Td>75-79</Td>
            <Td>C</Td>
            <Td>2.3</Td>
          </Tr>
          <Tr>
            <Td>70-74</Td>
            <Td>C-</Td>
            <Td>1.9</Td>
          </Tr>
          <Tr>
            <Td>65-69</Td>
            <Td>D</Td>
            <Td>1.4</Td>
          </Tr>
          <Tr>
            <Td>60-64</Td>
            <Td>D-</Td>
            <Td>1</Td>
          </Tr>
          <Tr>
            <Td>0-59</Td>
            <Td>F</Td>
            <Td>0</Td>
          </Tr>
        </Tbody>
      </Table>
    )
}